// TODO: Clean up service for PR

import {Injectable} from '@angular/core';
import {GoogleMap} from '@gbds/core';
import {AppConfigService} from '@ox/utils';
import {from} from 'rxjs';
import {MapConfig} from './map.value';

// Change name of interface
interface Markers {
  marker: any,
  infoWindow: any
}
const google = {
  get maps() {
    return window?.google?.maps as GoogleMap | any || null;
  }
};

@Injectable()
export class MapService {
  id = new Date().getTime();
  // TODO: Give proper types
  _map: any;
  _markers: Markers[] = [];
  map: any;
  element: Element;
  mapConfig: any;
  markers: any;
  loadGoogleMapsPromise: any = {};
  _directionsRenderer: any;
  startingAddress = '';

  constructor(
    private appConfig: AppConfigService
  ) {
  }

  setMap(mapElement: Element, mapConfig: unknown) {
    this.element = mapElement;
    this.mapConfig = mapConfig;
  }

  // Adds a marker to the map and an optional info window
  addMapMarker(markerInfo: any) { // find proper type
    const onGeocode = (results: any, status: any) => {
      const promise = new Promise((resolve, reject) => {
        if (results.isArray || status !== google.maps.GeocoderStatus.OK) {
          reject('No geocode results.');
          return;
        }

        settings.position = results[0].geometry.location;
        resolve(initMarker());
      });
      const obs = from(promise);
      return obs;
    };

    const initMarker = () => {
      let infoWindow: any;

      const marker = new google.maps.Marker({
        map: this._map,
        icon: settings.iconUrl,
        position: settings.position,
        title: settings.name
      });

      if (settings.shouldCenterOnAdd) {
        this._map.setCenter(marker.getPosition());
      }

      // Creates an InfoWindow associated with the marker if supplied
      if (settings.name) {
        infoWindow = new google.maps.InfoWindow({
          content: settings.name
        });

        google.maps.event.addListener(marker, 'mouseover', () => {
          infoWindow.open(this._map, marker);
        });

        google.maps.event.addListener(marker, 'mouseout', () => {
          infoWindow.close(this._map, marker);
        });

        if (settings.shouldOpenInfoOnAdd) {
          infoWindow.open(this._map, marker);
        }
      }

      const mapMarker = {marker: marker, infoWindow: infoWindow};
      this._markers.push(mapMarker);
      return mapMarker;
    };


    if (!this._map) {
      const promise = new Promise((reject) => {
        reject('No map object');
      });
      const obs = from(promise);
      return obs;
    }

    const settings = markerInfo;
    let geocoder;
    const markerPromise = new Promise((resolve, reject) => {
      if (settings.position) {
        return resolve(initMarker());
      }

      if (settings.address) {
        const addProm = new Promise(() => {
          geocoder = new google.maps.Geocoder();
          geocoder.geocode({'address': settings.address}, onGeocode);
        });
        const addObs = from(addProm);
        return addObs;
      }
      return reject('No address or position supplied.');
    });

    const markerObs = from(markerPromise);
    return markerObs;
  }

  centerMap(mapMarker?: any) {
    if (!this._map) return this;

    if (mapMarker && mapMarker.marker) {
      this._map.setCenter(mapMarker.marker.getPosition());
      return this;
    }

    if (this.markers.length && this.markers[0].marker) {
      this._map.setCenter(this.markers[0].marker.getPosition());
    }

    // this._map.setCenter();


    return this;
  }

  // Clears all markers from the map and resets the array
  clearMapMarkers() {

    this._markers.forEach((item: any) => {
      item.marker.setMap(null);
      item.infoWindow = null;
    });

    this._markers = [];
    return this;
  }

  hideMapMarkers() {

    if (!this._map) return this;

    this._markers.forEach((item: any) => {
      item.marker.setMap(null);
    });
    return this;

  }

  // Initializes the map object
  initializeMap() {
    const initMapPromise = new Promise((resolve, reject) => {

      const onSuccess = () => {
        this._map = new google.maps.Map(this.element, this.mapConfig.mapOptions);
        resolve(this);
      };

      if (this._map) resolve(this);
      if (!this.element) reject('invalid map element');
      if (!this.mapConfig) reject('invalid map config');


      // this.loadGoogleMaps(this.mapConfig)
      //   .pipe(
      //     map(() => onSuccess()));
      this.loadGoogleMaps(this.mapConfig)
        .subscribe(() => {
          onSuccess();
        });
    });

    this._markers = [];
    // Add read-only access to the markers
    Object.defineProperty(this, 'markers', {
      enumerable: true,
      configurable: true,
      get: () => {
        return this._markers;
      }
    });

    const initMapObs = from(initMapPromise);
    return initMapObs;
  }

  // Conditionally loads the Google Maps script
  loadGoogleMaps(mapConfig: any) {
    // var defer = $q.defer();
    const loadGoogleMapsPromise = new Promise<void>((resolve, reject) => {

      const setMapOptions = () => {
        mapConfig.mapOptions.zoomControlOptions.style = google.maps.ZoomControlStyle.LARGE;
        return resolve();
      };

      const _loadGoogleMaps = () => {
        const region = this.appConfig.bml?.market;
        const lang = this.appConfig.bml?.lang;
        const regionPath = '&region=' + region + '&language=' + lang + '-' + region?.toUpperCase();
        window.gm = window.gm || {};
        window.gm.googleMapsInitialized = setMapOptions;

        const script = document.createElement('script');
        script.type = 'text/javascript';

        script.src = MapConfig.googleMapsScriptUrl + regionPath + '&callback=gm.googleMapsInitialized';
        document.head.appendChild(script);
      };

      if (!mapConfig) return reject('invalid map config');

      // Determine if we need to load Google Maps
      if (google && google.maps) {
        return resolve(setMapOptions());
      }

      // Check if there is already an outstanding fetch in-progress
      // if (this.loadGoogleMapsPromise) {
      //   return this.loadGoogleMapsPromise;
      // } else {
      // Load the Google Maps script
      // this.loadGoogleMapsPromise = loadGoogleMapsPromise;

      _loadGoogleMaps();

      // }
    });
    const loadGoogleMapsObs = from(loadGoogleMapsPromise);
    return loadGoogleMapsObs;
  }

  // Clears any directions + markers and resets the map zoom to the default
  resetMap() {

    if (this._directionsRenderer) {
      this._directionsRenderer.setMap(null);
      this._directionsRenderer.setPanel(null);
    }

    this.clearMapMarkers();

    if (!this._map) return this;

    this._map.setZoom(this.mapConfig.mapOptions.zoom);

    return this;
  }

  // Resizes the map
  resizeMap() {

    const resizeMapPromise = new Promise<void>((reject) => {
      if (!this._map) return reject();

      // HACK: Angular timing / map redraw conflict
      return setTimeout(() => {
        google.maps.event.trigger(this._map, 'resize');
        this.zoomMap().centerMap();
      }, 500);
    });
    const resizeMapObs = from(resizeMapPromise);
    return resizeMapObs;
  }

  zoomMap(zoomLevel?: any) {

    if (!this._map) return this;

    if (!zoomLevel) {
      zoomLevel = this.mapConfig.mapOptions.zoom;
    }

    this._map.setZoom(zoomLevel);

    return this;
  }

  // Shows any markers associated with the map
  showMapMarkers() {

    if (!this._map) return this;

    this._markers.forEach((item: any) => {
      item.marker.setMap(this._map);
    });

    return this;
  }

  _getStartingAddress() {
    return this.startingAddress;
  }

  // here, we are checking to see if the start_address value exists and if so,
  // we are setting the startingAddress of the service object
  _parseResponseAndSetStartingAddress(response: any) {
    if (response && response.routes && response.routes[0] && response.routes[0].legs
      && response.routes[0].legs[0] && response.routes[0].legs[0].start_address) {
      this.startingAddress = response.routes[0].legs[0].start_address;
    }
  }
}
